module.exports = __webpack_public_path__ + "static/media/PersAnalytics.fc9d4114.svg";